import { ProfileAnswer } from "../../types/coreApiMirror";
import { getClassName } from "@pairtreefamily/utils";
import GalleryTile, { TileSize } from "./galleryTile";

export type AnswerProps = ProfileAnswer & { size: TileSize };

export function Answer(props: AnswerProps) {
  const compact = props.size === "sm";
  return (
    <>
      <p className="text-body-3-medium text-black">
        <strong>{props.question?.name}</strong>
      </p>
      {props.answer && (
        <p
          className={getClassName(
            compact ? "text-body-3-medium" : "text-body-1",
            "overflow-hidden before:content-[open-quote] after:content-[close-quote]",
          )}
        >
          {props.answer}
        </p>
      )}

      {props.adoptive_parent?.first_name && (
        <p className="text-body-3-medium">
          <em>-{props.adoptive_parent?.first_name}</em>
        </p>
      )}
    </>
  );
}

export function MediumAnswerTile(props: Omit<AnswerProps, "size">) {
  return (
    <GalleryTile size="md" className="bg-white p-8">
      <Answer {...props} size="md" />
    </GalleryTile>
  );
}

export function SmallAnswerTile(props: Omit<AnswerProps, "size">) {
  return (
    <GalleryTile size="sm" className="line-clamp-5 bg-white p-8">
      <Answer {...props} size="sm" />
    </GalleryTile>
  );
}

export default Answer;
